import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=5865ae63"
import script from "./LoadingButton.vue?vue&type=script&lang=ts"
export * from "./LoadingButton.vue?vue&type=script&lang=ts"
import style0 from "./LoadingButton.vue?vue&type=style&index=0&id=5865ae63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports